import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { MarketplaceGrid } from '@features/connections/generic/components/MarketplaceGrid';
import { ConnectionListItem } from '@features/connections/generic/components/ConnectionListItem';
import { useConnections } from '@shared/hooks';
import DialogHeader from '@shared/ui/dialog/DialogHeader';
import { Icon } from '@shared/icons';

const SignUpMarketplaces = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { connections } = useConnections();
  const [isAddConnectionDialogOpen, setIsAddConnectionDialogOpen] = useState(false);

  const hasConnections = (connections?.length ?? 0) > 0;

  return (
    <Box>
      <Typography variant="h6" fontWeight="medium" gutterBottom>
        Connect to your store
      </Typography>
      <Typography variant="body2" color="text.secondary" mb={3}>
        Be able to see all the data available
      </Typography>

      {hasConnections ? (
        <Box border={1} borderColor={theme.palette.divider} p={0} borderRadius={2}>
          {connections?.map((connection) => (
            <ConnectionListItem key={connection.id} connection={connection} />
          ))}

          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            borderTop={1}
            borderColor={theme.palette.divider}
            p={2}
          >
            <Typography variant="body2" color={theme.palette.text.secondary}>
              Need to connect another store?
            </Typography>
            <Button variant="text" onClick={() => setIsAddConnectionDialogOpen(true)}>
              Add another connection
            </Button>
          </Stack>
        </Box>
      ) : (
        <MarketplaceGrid onNewConnection={() => undefined} />
      )}

      <Stack
        direction="row"
        spacing={2}
        sx={{
          mt: 4,
          justifyContent: 'flex-end',
        }}
      >
        <Button
          variant={hasConnections ? 'contained' : 'outlined'}
          onClick={() => navigate('/sign-up/complete')}
          size="medium"
        >
          {hasConnections ? 'Continue' : 'Skip for now'}
        </Button>
      </Stack>

      <Dialog
        open={isAddConnectionDialogOpen}
        onClose={() => setIsAddConnectionDialogOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogHeader>
          <Stack direction="row" justifyContent="space-between" alignItems="center">
            <Typography variant="h6">Add a connection</Typography>
            <IconButton onClick={() => setIsAddConnectionDialogOpen(false)}>
              <Icon icon="X01" />
            </IconButton>
          </Stack>
        </DialogHeader>
        <DialogContent>
          <Box sx={{ pt: 2 }}>
            <MarketplaceGrid
              onNewConnection={() => {
                setIsAddConnectionDialogOpen(false);
              }}
            />
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
};

export default SignUpMarketplaces;
